import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MiscellaneousServicesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"miscellaneous_services"}/>
}
